//import { asyncRoutes, resetRouter } from '../router'
import { resetRouter } from '../router'

// 将菜单信息转成对应的路由信息 动态添加
export function menusToRoutes(data) {
    const result = []
    const children = []
    result.push({
        path: '/',
        component: () => import('../components/Index.vue'),
        children,
    })

    data.forEach(item => {
        generateRoutes(children, item)
    })

    children.push({
        path: 'error',
        name: 'error',
        component: () => import('../components/Error.vue')
    })

    // 最后添加404页面 否则会在登陆成功后跳到404页面
    result.push(
        {path: '*', redirect: '/error'},
    )
    return result
}

function generateRoutes(children, item) {
    if (item.name) {
        children.push(asyncRoutes[item.name])
    } else if (item.children) {
        item.children.forEach(e => {
            generateRoutes(children, e)
        })
    }
}

export function resetTokenAndClearUser() {
    // 退出登陆 清除用户资料
    localStorage.removeItem('token')
    //localStorage.setItem('userImg', '')
    localStorage.removeItem('userName')
    localStorage.removeItem('crumbs')
    localStorage.removeItem('menu')
    localStorage.removeItem('user_id')
    localStorage.removeItem('isHasMenu')
    // 重设路由
    resetRouter()
}




// WEBPACK FOOTER //
// ./src/utils/index.js